::ng-deep particle-mail-detail-content{display:flex;width:100%}.mail-template-content-container{display:flex;flex-grow:1}.mail-template-content-container:last-child{margin-bottom:0}
/*# sourceMappingURL=mail-thread.component-TDW7PI6Z.css.map */
